import { createAction } from 'redux-actions'

export const types = {
    API_CALL_FAILURE: 'donorRolls/API_CALL_FAILURE',
    ASSIGN_DONOR_ROLL_SETTINGS: 'donorRolls/ASSIGN_DONOR_ROLL_SETTINGS',
    POPULATE_DONOR_ROLL_DATA: 'donorRolls/POPULATE_DONOR_ROLL_DATA',
    TOGGLE_OVERRIDE_DISPLAY_LIMIT: 'donorRolls/TOGGLE_OVERRIDE_DISPLAY_LIMIT',
}

export const actions = {
    apiCallFailure: createAction<string>(types.API_CALL_FAILURE),
    assignDonorRollSettings: createAction<DonorRollSettingsDto>(types.ASSIGN_DONOR_ROLL_SETTINGS),
    populateDonorRollData: createAction<ApiDonorRollDataRecord[]>(types.POPULATE_DONOR_ROLL_DATA),
    toggleDonorRollOverrideDisplayLimit: createAction(types.TOGGLE_OVERRIDE_DISPLAY_LIMIT),
}
